require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-project-bosques-en-peru.json") })
        }
      }, "path---es-mx-project-bosques-en-peru");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-project-bosques-en-peru!./.cache/json/es-mx-project-bosques-en-peru.json
// module id = 895
// module chunks = 231608221292675